<template>
  <div class="yubikey-factor-component">
    <template v-if="!codeExpired">
      <p class="color-white mb-md">E-mailcode</p>

      <p>
        <!--      <CodeInput ref="input" :fields="6" :loading="false" v-on:change="onChange" v-on:complete="onComplete"/>-->
        <a-input v-model="value" ref="input"
                 v-on:keyup.enter.native.prevent="onSubmit"
                 v-bind:class="{'has-error': !valid}"
                 v-on:focus="() => {valid = true}"
                 v-on:blur="validateYubikey">
        </a-input>
      </p>

      <a-button :loading="loading" size="large" type="primary" block
                v-on:click="onSubmit" style="margin-bottom: 40px;">
        Inloggen
      </a-button>

      <p class="color-white mb-md">
        De verstuurde code is nog
        <CountdownTimerComponent :seconds="900" :human="true" v-on:done="showCodeExpired"></CountdownTimerComponent>
        geldig.
      </p>
    </template>
    <template v-else>
      <p class="color-white mb-md">
        De verstuurde code is niet meer geldig.
      </p>

      <a-button :loading="loading" size="large" type="primary" block
                v-on:click="onResendEmailCode" style="margin-bottom: 15px;">
        Nieuwe e-mailcode opvragen
      </a-button>

      <p class="color-white mb-md">
        Controleer bij de volgende aanvraag ook uw spamfolder.
        Heeft u geen mail ontvangen neem dan contact met ons op.
      </p>

      <p class="color-white mb-md">
        <phone-icon/>
        050 - 767 6666
      </p>
      <p class="color-white mb-md">
        <email-icon/>
        support@dossierdata.nl
      </p>

    </template>

    <p class="color-white mb-md">
      Wilt u met uw Yubikey inloggen, klik dan op de link hieronder.
    </p>

    <a-button type="link" block ghost @click="onLoginFactorYubikeyClick">
      Inloggen met Yubikey
    </a-button>
  </div>
</template>

<script>
import authApi from "~/api/auth";
import CountdownTimerComponent from "../../../components/CountdownTimerComponent";
import CodeInput from "vue-verification-code-input";

export default {
  name: "EmailFactorComponent",
  components: {
    CountdownTimerComponent,
    CodeInput
  },
  props: {
    username: {
      type: String,
      required: true,
    },
    password: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      value: '',
      loading: false,
      valid: true,
      codeExpired: false
    }
  },
  computed: {},
  methods: {
    validateYubikey(e) {
      // let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      this.valid = (
          (this.value.length > 0)
      );
    },
    onChange(value) {
      this.value = value;
    },
    onComplete(value) {
      this.value = value;
      this.onSubmit();
    },
    onSubmit() {
      this.loading = true;
      this.$emit('submit', this.value);
    },
    onResendEmailCode() {
      this.loading = true;
      authApi.sendEmailCode(this.username, this.password).then(() => {
        this.codeExpired = false;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$notification['error']({
          message: 'Er ging iets fout',
        });
      });
    },
    onCancelClick() {
      this.$emit('cancel');
    },
    onLoginFactorYubikeyClick() {
      this.$emit('switch-factor', 'yubi');
    },
    showCodeExpired() {
      this.codeExpired = true;
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.input.focus();
    }, 500);
  }
}
</script>

<style scoped>
.auth-panel {
  background-color: #1a4b6c;
  color: white;
}

.side-image {
  background-size: cover;
  background-position: center left;
}

.auth-panel .content {
  padding: 3rem 4rem;
  min-height: 35rem;
}

.auth-panel .content .title {
  font-size: 3rem;
  color: white;
}

.auth-panel .steps {
  margin: -1rem 0rem 1rem 0rem;
  color: rgba(255, 255, 255, 0.5);
}

.auth-panel .steps .active {
  color: white;
}

.has-error {
  border-color: #ff4040;
  box-shadow: 0 0 0 2px rgba(255, 24, 24, 0.2);
}
</style>
